/*
 * Copyright (c) 2023 Irian Software Development SRL. All Rights Reserved.
 * This software is the proprietary information of Irian Software Development SRL.
 * Use is subject to license and non-disclosure terms
 */

import { Injectable } from '@angular/core';
import { AbstractResourceService } from '../utils/abstract-resource.service';
import { EndpointService } from '../utils/endpoint.service';
import { assign } from 'lodash';
import { Resource } from '../utils/resource.model';

@Injectable()
export class ReferencedPlaceService extends AbstractResourceService {
  constructor(endpointService: EndpointService) {
    super(endpointService, '/api/referenced-places');
  }

  override resourceMapper(resourceJSON: unknown) {
    return assign(new Resource(), resourceJSON);
  }
}
